import * as React from "react";
import {isFromAccountingTeam, isFromTechTeam} from '../../../auth/UserPermissions';
import Box from '@amzn/awsui-components-react/polaris/box';
import PermissionsModal from '../../PermissionsModal';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import {TestCaseType} from '../model/TestCaseType';
import ButtonDropdown from '@amzn/awsui-components-react/polaris/button-dropdown';


export default function AddTestCaseTypeDropDown(props) {
    const [hasAccess] = React.useState(isFromTechTeam() || isFromAccountingTeam());
    const [selectedId, setSelectedId] = React.useState("");

    const onSelectionChange = (event: CustomEvent) => {
        event.preventDefault();

        const selection = event.detail.id;
        const testCaseType: TestCaseType = selection as TestCaseType;

        setSelectedId(selection);
        props.setTestCaseType(testCaseType);
    }

    return (
        <Box>
            {!hasAccess && <PermissionsModal hasPageAccess={hasAccess}/>}
            {hasAccess && <SpaceBetween direction='vertical' size='xl'>
                <ButtonDropdown
                    onItemClick={onSelectionChange}
                    items={[
                        {
                            id: TestCaseType[TestCaseType.SINGLE],
                            text: "SINGLE",
                            description: "Single Test Case: Run independent individual test cases.",
                        },
                        {
                            id: TestCaseType[TestCaseType.SCENARIO],
                            text: "SCENARIO",
                            description: "Scenario Test Case: Run dependent test cases, where output of one event can influence the output of next event.",
                            disabled: true
                        },
                    ]}
                >
                    {selectedId}
                </ButtonDropdown>
            </SpaceBetween>}
        </Box>
    );
}